import { render, staticRenderFns } from "./PatientTabsCellRenderer.vue?vue&type=template&id=5be80173&scoped=true&"
import script from "./PatientTabsCellRenderer.vue?vue&type=script&lang=js&"
export * from "./PatientTabsCellRenderer.vue?vue&type=script&lang=js&"
import style0 from "./PatientTabsCellRenderer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PatientTabsCellRenderer.vue?vue&type=style&index=1&id=5be80173&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be80173",
  null
  
)

export default component.exports